// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:31:33.940Z
// Property: FortyOne 11 (ID: 6767906449166806)
// Collections: 19 amenities, 12 floorplans (live), 34 photos, 33 POIs, 9 reviews, 8 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166806",
  "property_external_id": "ym5x19r",
  "property_zillow_url": "https://www.zillow.com/apartments/portland-or/fortyone-11/Ch87pW/",
  "property_apartments_url": "https://www.apartments.com/forty-one-11-portland-or/ym5x19r/",
  "property_google_business_url": "https://www.google.com/maps/place/FortyOne11+Apartments/data=!4m2!3m1!1s0x0:0x24745182bf1cf8e6?sa=X&ved=2ahUKEwiDgpb856eSAxW_r1YBHcsiEtUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "41629066548",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "563FT1",
  "property_status": null,
  "property_slug": "forty-one-11",
  "property_name": "FortyOne 11",
  "property_website_url": "https://www.fortyone11pdx.com/",
  "property_domain": "https://www.fortyone11pdx.com/",
  "property_address": "4111 Northeast Martin Luther King Junior Boulevard",
  "property_full_address": "4111 NE Martin Luther King Jr Blvd, Portland, OR 97211",
  "property_address_1": "4111 NE Martin Luther King Jr Blvd",
  "property_address_2": null,
  "property_address_city": "Portland",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97211",
  "property_address_country": "US",
  "property_address_county": "Multnomah County",
  "property_neighborhood_address": "King",
  "property_address_latitude": "45.5534613",
  "property_address_longitude": "-122.6618489",
  "property_email": null,
  "property_phone": "(971) 290-1106",
  "property_call_tracking_phone": "855-398-7035",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to FortyOne 11, Portland's premier apartment community where modern living meets comfort. Choose from stylish studio, one, or two-bedroom floor plans featuring quartz countertops, vaulted ceilings, and private balconies. Enjoy exceptional amenities like a fitness center, lounge with WiFi, and secure parking. Your ideal home awaits!",
  "property_long_description": "Welcome to FortyOne 11, your ideal apartment community nestled in the heart of Portland, OR. With a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedrooms, and modern two-bedrooms, we have the perfect home for everyone. Each apartment features high-end finishes such as wood-style flooring, quartz countertops, and energy-efficient stainless-steel appliances, ensuring you enjoy both style and functionality. \n\nStep into a world of comfort with in-unit amenities, including a washer and dryer, dishwashers, and private balconies* that offer stunning views and the perfect spot for relaxation. For those who enjoy an active lifestyle, our fitness center is equipped with cardio machines and free weights, while the community lounge area provides a great space to connect with neighbors, complete with complimentary Wi-Fi.\n\nSafety and convenience are paramount at FortyOne 11, featuring a secure building entry system, gated and off-street parking, and package lockers for hassle-free deliveries. Enjoy the lush landscapes of nearby parks and indulge in the luxury of vaulted ceilings and floor-to-ceiling windows that fill your apartment with natural light.\n\nExperience modern living at its finest in Portland. Don't miss your chance to be part of our welcoming community. Find your new home today — browse our availability or schedule a tour to visit FortyOne 11!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-1a14-75ec-af93-6af11975382a.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment building exterior with gray and white facade, yellow accents, and large windows.",
    "public_id": "019f394e-1a14-75ec-af93-6af11975382a",
    "storage_key": "property/6767906449166806/019f394e-1a14-75ec-af93-6af11975382a.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "105",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.23809523809523",
  "property_admin_fee": null,
  "property_application_fee": "65",
  "property_fees_deposit_info": "300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats are allowed. Maximum of two pets per apartment.",
  "property_pet_policy_description": "Dogs and cats are allowed. Pet deposit: $300 per pet. Monthly pet rent: $35 per pet. Maximum of two pets per apartment.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcfortyone11",
  "property_resident_portal_url": "https://fortyone11.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcfortyone11/NJQ9C",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-1105-72ce-b4d0-0292fd6879d0.webp",
  "property_primary_logo_media": {
    "alt_text": "Fortyone 11 logo",
    "public_id": "019d02d1-1105-72ce-b4d0-0292fd6879d0",
    "storage_key": "property/6767906449166806/019d02d1-1105-72ce-b4d0-0292fd6879d0.webp",
    "width": 217,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d3-094f-74f5-9d71-80069eafd1b3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fortyone 11 property logo",
    "public_id": "019d02d3-094f-74f5-9d71-80069eafd1b3",
    "storage_key": "property/6767906449166806/019d02d3-094f-74f5-9d71-80069eafd1b3.webp",
    "width": 217,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d3-110b-703c-b054-59486782f922.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Fortyone 11 logo",
    "public_id": "019d02d3-110b-703c-b054-59486782f922",
    "storage_key": "property/6767906449166806/019d02d3-110b-703c-b054-59486782f922.webp",
    "width": 217,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#111111",
  "property_secondary_color": "#B71C1C",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": null,
  "property_sqft_range": "394 - 931",
  "property_sqft_min": "394",
  "property_sqft_max": "931",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1949",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/fortyone11apts/",
  "property_instagram_url": "https://www.instagram.com/fortyone11apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJw2nFMqynlVQR5vgcv4JRdCQ",
  "property_youtube_url": "https://www.youtube.com/watch?t=109&v=5Zg0YR0f_ZA",
  "property_yelp_url": "https://www.yelp.com/biz/northeast-health-center-portland",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to FortyOne 11",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "At FortyOne 11 in Portland, OR, modern living meets unparalleled convenience. Enjoy spacious floor plans adorned with quartz countertops and vaulted ceilings. Elevate your lifestyle with our fitness center, community lounge, and secure parking. Experience the essence of community coupled with luxurious apartment features tailored for you.",
  "property_home_floorplans_blurb": "Welcome to FortyOne 11 in vibrant Portland, OR, where contemporary design meets urban convenience. Choose from an array of thoughtfully crafted floor plans that elevate your living experience. Embrace the essence of city life while enjoying a space that reflects your style. Browse our available apartment homes today!",
  "property_home_gallery_blurb": "At FortyOne 11 in vibrant Portland, OR, modern living meets comfort. Enjoy spacious apartments featuring floor-to-ceiling windows, energy-efficient appliances, and private balconies. Stay active in our fitness center or unwind in the community lounge. With secure parking and proximity to parks, picture yourself thriving in this dynamic community!",
  "property_home_neighborhood_blurb": "At FortyOne 11 in Portland, OR, vibrant city life meets cozy living. Choose from studio, one-, or two-bedroom floor plans and immerse yourself in a neighborhood rich with culture. Enjoy nearby gems like Powell's City of Books, the Portland Japanese Garden, and Multnomah County Central Library—all at your doorstep.",
  "property_home_reviews_blurb": "Nestled in the vibrant heart of Portland, FortyOne 11 offers more than just stylish living spaces; it's a welcoming community. Residents rave, \"The management truly cares about us,\" highlighting our commitment to exceptional service. Experience the difference for yourself—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At FortyOne 11 in Portland, OR, immersing yourself in a vibrant community is effortless. Picture weekends spent at the Oregon Zoo, the tranquility of the Portland Japanese Garden, or the excitement of events at Moda Center. Proximity to educational institutions, parks, and cultural landmarks makes your new home an urban adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At FortyOne 11 in vibrant Portland, OR, elevate your lifestyle with thoughtfully designed studio, one, and two-bedroom apartments. Enjoy high-end finishes, including quartz countertops and stainless-steel appliances, and unwind in our inviting community lounge or modern fitness center. Benefit from secure access, luxury amenities, and a location close to parks.",
  "property_applynow_blurb": "At FortyOne 11 in vibrant Portland, OR, you’ll find stylish studios, one, and two-bedroom homes featuring vaulted ceilings and floor-to-ceiling windows. Enjoy upscale amenities like a modern fitness center, secure entry, and a welcoming lounge with WiFi. Embrace comfort and convenience—apply online and claim your new sanctuary today!",
  "property_contactus_blurb": "At FortyOne 11 in vibrant Portland, OR, you'll find the perfect floor plan tailored to your lifestyle—whether it’s a cozy studio, a spacious one-bedroom, or a stylish two-bedroom. Our leasing team is ready to assist. Have questions? Reach out today and let’s make your dream home a reality!",
  "property_faqs_blurb": "At FortyOne 11 in Portland, OR, we offer a range of stylish studio, one-bedroom, and two-bedroom floor plans designed for modern living. Curious about our community? Our FAQs page is your go-to resource for all your inquiries—dive in and find the answers you need today!",
  "property_floorplans_blurb": "At FortyOne 11 in Portland, OR, your ideal living space awaits. Choose from our stylish studio, spacious one-bedroom, or expansive two-bedroom floor plans, each designed for modern comfort and convenience. Dive into our diverse options and find the perfect apartment home that complements your vibrant lifestyle.",
  "property_gallery_blurb": "At FortyOne 11 in Portland, OR, picture your ideal home with floor-to-ceiling windows, elegant quartz countertops, and modern amenities like a fitness center and community lounge with WiFi. Experience comfort with in-unit washers, private balconies*, and energy-efficient appliances—all just steps away from beautiful parks. Your new lifestyle awaits!",
  "property_interactivemap_blurb": "At FortyOne 11 in Portland, OR, each thoughtfully designed apartment offers wood-style flooring, quartz countertops, and energy-efficient appliances. Enjoy exclusive amenities like a fitness center, community lounge, and private balconies. Use our interactive community map to uncover your perfect studio, one, or two-bedroom retreat today!",
  "property_pets_blurb": "At FortyOne 11 in vibrant Portland, OR, your furry companions are embraced with open arms. Enjoy spacious apartments designed for both comfort and style, while your pets enjoy the city’s numerous parks and pet-friendly spots. With a $300 deposit and a monthly rent of just $35 per pet, life here is perfect for you and your four-legged friends!",
  "property_referafriend_blurb": "At FortyOne 11 in vibrant Portland, OR, choose from stylish studio, one-bedroom, or two-bedroom apartments designed for modern living. Share your joy—great friends make great neighbors. Refer a friend today and let them experience our welcoming community and exceptional amenities! Together, embrace the life you love!",
  "property_residentaccess_blurb": "At FortyOne 11 in vibrant Portland, OR, your perfect home awaits—whether you’re searching for a cozy studio, a spacious one-bedroom, or a roomy two-bedroom apartment. Log into your resident portal for seamless rent payments, quick maintenance requests, and exclusive community updates. Your comfort is just a click away!",
  "property_reviews_blurb": "At FortyOne 11 in Portland, OR, residents rave, “This community feels like home, with exceptional amenities and a welcoming atmosphere.” Experience a vibrant lifestyle surrounded by breathtaking views and beautiful landscapes. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_created_at": "1762201378854",
  "property_scheduletour_blurb": "At FortyOne 11 in vibrant Portland, OR, you'll find thoughtfully designed studio, one-bedroom, and two-bedroom apartments tailored to your lifestyle. Experience comfort and community where every detail counts. Schedule a tour today, and hear firsthand from our residents about why they love calling FortyOne 11 home!",
  "property_thankyou_blurb": "Thank you for reaching out to FortyOne 11! Nestled in the heart of Portland, our diverse floor plans—ranging from cozy studios to spacious two-bedroom apartments—are designed to elevate your living experience. Expect a swift response from our team to help you find your perfect home!",
  "property_virtualtours_blurb": "At FortyOne 11 in vibrant Portland, OR, your perfect living space awaits! Whether you're drawn to our cozy studio, spacious one-bedroom, or expansive two-bedroom apartments, each floor plan offers a unique charm. Immerse yourself in our community—take a virtual tour today and envision your future home!",
  "property_copyright": "2025 All Rights Reserved. FortyOne 11",
  "property_seo_title_home": "FortyOne 11 |  Apartments in Portland, OR",
  "property_seo_description_home": "Welcome to FortyOne 11 in Portland, OR! Enjoy modern living with spacious floor plans and top-notch amenities. Your ideal apartment is just a click away!",
  "property_seo_title_floorplans": "Floor Plans | Portland, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at FortyOne 11 in Portland, OR. Choose from stylish studio, one, or two-bedroom apartments—your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Portland, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at FortyOne 11 in Portland, OR! Enjoy modern amenities, spacious floor plans, and a vibrant community—all designed for your ideal lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Portland, OR",
  "property_seo_description_gallery": "Capture the essence of Portland living at FortyOne 11. Picture yourself in modern, stylish apartments featuring vibrant amenities and breathtaking views.",
  "property_seo_title_virtualtours": "Virtual Tours | FortyOne 11 Apartments",
  "property_seo_description_virtualtours": "Step into your dream home at FortyOne 11 in Portland, OR. Experience stunning studio, one, and two-bedroom apartments. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | FortyOne 11 Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at FortyOne 11 in Portland! Explore stylish studios to spacious two-bedrooms with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Portland, OR",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhoods surrounding FortyOne 11 in Portland, OR. Dive into local favorites and hidden gems just steps from your future home!",
  "property_seo_title_contact": "Contact Us | FortyOne 11",
  "property_seo_description_contact": "Connect with our leasing team at FortyOne 11 in Portland, OR! Inquire about our diverse floor plans: studios, one & two bedrooms. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Portland, OR",
  "property_seo_description_faqs": "Uncover the answers to your questions about living at FortyOne 11 in Portland, OR. Browse our FAQs to learn about our community and amenities today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Portland, OR",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at FortyOne 11 in Portland, OR. Read resident reviews and learn why our community is the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Portland, OR",
  "property_seo_description_applynow": "Elevate your lifestyle at FortyOne 11 in Portland! Choose from studios to two-bedrooms with modern amenities. Lease online now! ",
  "property_seo_title_residentaccess": "Resident Access | FortyOne 11",
  "property_seo_description_residentaccess": "Unlock seamless living at FortyOne 11 in Portland, OR! Access your resident portal to manage rent, schedule maintenance, and enhance your community experience.",
  "property_seo_title_referafriend": "Refer A Friend | FortyOne 11",
  "property_seo_description_referafriend": "Refer a friend to FortyOne 11 in Portland, OR! Share the joy of great living, make lasting memories, and enjoy exclusive rewards together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | FortyOne 11",
  "property_seo_description_scheduletour": "Experience the charm of FortyOne 11 in vibrant Portland, OR. Schedule your tour today and envision your new lifestyle in our modern apartment community!",
  "property_seo_title_privacy": "Privacy Policy | FortyOne 11",
  "property_seo_description_privacy": "At FortyOne 11 in Portland, your privacy matters. Learn about our commitment to safeguarding your personal information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | FortyOne 11",
  "property_seo_description_accessibility": "At FortyOne 11 in Portland, we embrace digital inclusivity. Our commitment ensures everyone can access information easily. Join our welcoming community today!",
  "property_seo_title_sitemap": "Sitemap | FortyOne 11",
  "property_seo_description_sitemap": "Uncover the heart of FortyOne 11 in Portland, OR. Navigate through our sitemap to find your perfect home and embrace a vibrant community lifestyle!",
  "property_seo_title_thankyou": "Thank You | FortyOne 11",
  "property_seo_description_thankyou": "Thank you for reaching out to FortyOne 11 in vibrant Portland, OR! Our team will be in touch soon—get ready for your new home adventure!",
  "property_seo_title_pets": "Pet Policy | Apartments in Portland, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293633965",
  "amenities": [
    {
      "id": "custom_f980a819-5251-413c-a0b3-a8a1590972f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Community Lounge Area w/ WiFi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b921c354-f0c9-473d-93c4-a5662d3b10c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center w/ Cardio Machine & Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd5a0c7c-9e07-4560-a030-252a1b80f290",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Parks",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8454f32-bf24-4b38-87ca-6da536dd6a7e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Building Entry System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db87f412-2f56-47f6-a2a8-4c5bc7271aa3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Gated & Off‑Street Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c42189e4-7158-4b57-9028-073915af7a8f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_620832bb-8fb7-44de-aa73-3245e413b9be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3eca9bb2-e893-4755-ba82-71ac2c0e11c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Portable A/C Ports",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_322ce496-bdd2-47b9-9330-58200fae9273",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8cd7a1e-6523-4abb-a613-8ee26b2a9fd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1012e234-daf8-4033-8165-25bd104ec256",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e5bbf82-d0e2-41fd-af2a-5cf8afb34461",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Roller‑Style Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83738ec1-9d65-4aee-b131-41193699d2de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Interior Apartment Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17908ee7-116c-44a4-aa3b-9e998becc2a8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Floor‑to‑Ceiling Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc5af53f-d619-4953-a381-94b7488f84c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77b350bb-316d-4f4b-b788-ff2f7e2c4975",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑Efficient & Stainless‑Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa01bc7d-bb43-43f4-9905-3d0e7300a254",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b124e2cf-62c8-4056-8dd0-b5b107b884c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "In‑Unit Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20c6df8d-b569-472e-b586-862c4e597896",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "external_id": "false",
      "title": "Vending Machine",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_94a92367-1ca5-4bf2-8ace-eba631bd7f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-e19b-74eb-8f85-50364e974562.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with large windows and yellow accents, surrounded by lush green trees at FortyOne 11 in Portland, OR.",
        "public_id": "019f394d-e19b-74eb-8f85-50364e974562",
        "storage_key": "property/6767906449166806/019f394d-e19b-74eb-8f85-50364e974562.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover contemporary living in this striking apartment building. Its sleek design, featuring large windows and vibrant yellow details, complements the surrounding natural beauty.",
      "link": "",
      "alt_text": "Modern apartment building exterior with large windows and yellow accents, surrounded by lush green trees at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0b174de-2912-4509-84c3-1b896b0fd3ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-87ff-729e-be43-dffbc9097fa7.webp",
      "image_media": {
        "alt_text": "Exterior aerial view of a modern apartment building surrounded by trees and residential homes at FortyOne 11 in Portland, OR.",
        "public_id": "019f394e-87ff-729e-be43-dffbc9097fa7",
        "storage_key": "property/6767906449166806/019f394e-87ff-729e-be43-dffbc9097fa7.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Captivating aerial view showcasing the modern architecture of the apartment building, nestled amidst lush greenery and a charming neighborhood.",
      "link": "",
      "alt_text": "Exterior aerial view of a modern apartment building surrounded by trees and residential homes at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_327a0e57-f6c7-4ec1-95ee-f7c8caaa3f96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-79e7-72c5-a4c7-1a04be1c8e6b.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with gray siding and yellow accents, surrounded by trees at FortyOne 11 in Portland, OR.",
        "public_id": "019f394e-79e7-72c5-a4c7-1a04be1c8e6b",
        "storage_key": "property/6767906449166806/019f394e-79e7-72c5-a4c7-1a04be1c8e6b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover modern living in this striking apartment building. Featuring sleek gray siding and vibrant yellow accents, the exterior design complements the lush surrounding trees, offering a stylish urban oasis.",
      "link": "",
      "alt_text": "Modern apartment building exterior with gray siding and yellow accents, surrounded by trees at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e75b74d8-520d-4cda-8581-2c2917032bf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-57a3-7750-a384-c7a2ff9844be.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with wood and concrete accents and large windows at FortyOne 11 in Portland, OR.",
        "public_id": "019f394e-57a3-7750-a384-c7a2ff9844be",
        "storage_key": "property/6767906449166806/019f394e-57a3-7750-a384-c7a2ff9844be.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Modern and stylish apartment building exterior featuring a combination of wood, concrete, and metal facade, with large windows and welcoming entrances.",
      "link": "",
      "alt_text": "Modern apartment building exterior with wood and concrete accents and large windows at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28a84343-05f5-4fb6-b049-efe13e4424ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0bf7-718d-a31e-3bc7e7794d1b.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with dramatic sunset sky and street view.",
        "public_id": "019f394e-0bf7-718d-a31e-3bc7e7794d1b",
        "storage_key": "property/6767906449166806/019f394e-0bf7-718d-a31e-3bc7e7794d1b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment building, perfectly situated with a vibrant streetscape and dramatic sunset views.",
      "link": "",
      "alt_text": "Modern apartment building exterior with dramatic sunset sky and street view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2647dd3c-8e20-4a19-aa34-c8df43fd2932",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-1a14-75ec-af93-6af11975382a.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with gray and white facade, yellow accents, and large windows.",
        "public_id": "019f394e-1a14-75ec-af93-6af11975382a",
        "storage_key": "property/6767906449166806/019f394e-1a14-75ec-af93-6af11975382a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Experience contemporary living at this stunning apartment building, featuring a striking modern design with clean lines and ample natural light.",
      "link": "",
      "alt_text": "Modern apartment building exterior with gray and white facade, yellow accents, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddee602a-dd73-44de-ba51-0859be74e71a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0b38-7774-8134-1b918e5553f9.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at sunset with car light trails on the street.",
        "public_id": "019f394e-0b38-7774-8134-1b918e5553f9",
        "storage_key": "property/6767906449166806/019f394e-0b38-7774-8134-1b918e5553f9.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience urban living in this modern apartment building, beautifully captured at sunset. Enjoy the vibrant city lights and serene sky from your new home.",
      "link": "",
      "alt_text": "Modern apartment building exterior at sunset with car light trails on the street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_744913de-7170-4eab-bd92-f7a3842e554e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-e266-7019-a3e8-b1ae11cfd18f.webp",
      "image_media": {
        "alt_text": "Exterior of the Forty One Eleven apartment building with large windows and signage at FortyOne 11 in Portland, OR.",
        "public_id": "019f394d-e266-7019-a3e8-b1ae11cfd18f",
        "storage_key": "property/6767906449166806/019f394d-e266-7019-a3e8-b1ae11cfd18f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Modern apartment building exterior, featuring large windows and prominent \"Forty One 11\" signage. Available for urban apartment living.",
      "link": "",
      "alt_text": "Exterior of the Forty One Eleven apartment building with large windows and signage at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e122c284-c86f-42cc-8234-6cb4e66e6757",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-815d-745e-a281-862b999b6a41.webp",
      "image_media": {
        "alt_text": "Bright living room with large windows, beige sofa, glass coffee table, and a potted plant.",
        "public_id": "019d20b7-815d-745e-a281-862b999b6a41",
        "storage_key": "property/6767906449166806/019d20b7-815d-745e-a281-862b999b6a41.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living room with large windows, a beige sofa, glass coffee table, and a potted plant.",
      "link": "",
      "alt_text": "Bright living room with large windows, beige sofa, glass coffee table, and a potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7IdfxNPmdCIyqck8foPQj9LZ5UBdnSDpVQ6uTaANiC8/116/image.jpg"
    },
    {
      "id": "custom_27af865d-0f49-4773-83b3-7fda824c464a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-8f91-7358-9be6-760394620430.webp",
      "image_media": {
        "alt_text": "Compact home office setup with a black desk, computer, and plants against a light, paneled wall at FortyOne 11 in Portland, OR.",
        "public_id": "019d20b7-8f91-7358-9be6-760394620430",
        "storage_key": "property/6767906449166806/019d20b7-8f91-7358-9be6-760394620430.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Modern apartment interior featuring a compact office desk and seating area.",
      "link": "",
      "alt_text": "Compact home office setup with a black desk, computer, and plants against a light, paneled wall at FortyOne 11 in Portland, OR.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lp-CUhEKGfIn4XFN9Lb0EW_3Uy1o34V5fFjZV7NMrSQ/116/image.jpg"
    },
    {
      "id": "custom_2f735205-945d-47c9-8516-7d91a9c7a0bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-e353-7004-a2fb-f3a149a38850.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with white bedding, a plant, and abstract wall art.",
        "public_id": "019d02d1-e353-7004-a2fb-f3a149a38850",
        "storage_key": "property/6767906449166806/019d02d1-e353-7004-a2fb-f3a149a38850.webp",
        "width": 2100,
        "height": 1400
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with white quilt, colorful pillows, a plant, and contemporary wall art.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with white bedding, a plant, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166806%2Faec9214df15eeec8d0ca1c4ce1679648.jpg"
    },
    {
      "id": "custom_f64a31f0-47d6-42bc-8ff5-b8c1785e6650",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-e3b9-77d8-9c95-84955f7e67f0.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with large windows, mustard sofa, glass coffee table, and a TV.",
        "public_id": "019d02d1-e3b9-77d8-9c95-84955f7e67f0",
        "storage_key": "property/6767906449166806/019d02d1-e3b9-77d8-9c95-84955f7e67f0.webp",
        "width": 2100,
        "height": 1400
      },
      "title": "Apartment",
      "description": "Bright contemporary living room in a modern apartment with expansive windows and minimalist furnishings.",
      "link": "",
      "alt_text": "Living room in a modern apartment with large windows, mustard sofa, glass coffee table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166806%2Ff8bb2c5b9a45a16259972d76addea90a.jpg"
    },
    {
      "id": "custom_bd69b837-b0b3-4506-a236-1e085195d4f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-f4ea-73bf-baae-bba8819b121f.webp",
      "image_media": {
        "alt_text": "Modern apartment living room with gray sofa, patterned chair, plant, and wall art.",
        "public_id": "019d02d1-f4ea-73bf-baae-bba8819b121f",
        "storage_key": "property/6767906449166806/019d02d1-f4ea-73bf-baae-bba8819b121f.webp",
        "width": 2100,
        "height": 1400
      },
      "title": "Apartment",
      "description": "A stylish living room in a modern apartment featuring a gray sofa, patterned chair, plant, and abstract wall art.",
      "link": "",
      "alt_text": "Modern apartment living room with gray sofa, patterned chair, plant, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166806%2Ff329d56361347e444b6700b3f19b2c5f.jpg"
    },
    {
      "id": "custom_d396a78f-35fb-4fc5-90d2-3dc158c80566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-7667-716e-9499-ef986e63dc49.webp",
      "image_media": {
        "alt_text": "Hallway with mailboxes and a dog statue.",
        "public_id": "019f394e-7667-716e-9499-ef986e63dc49",
        "storage_key": "property/6767906449166806/019f394e-7667-716e-9499-ef986e63dc49.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Mailroom with mailboxes, statue, and elevator entrance.",
      "link": "",
      "alt_text": "Hallway with mailboxes and a dog statue.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc29b4de-2bde-4c11-9b7f-8301d63d7223",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-7389-7068-a1c5-7c8631098418.webp",
      "image_media": {
        "alt_text": "The \"FORTYONE 11\" building entrance with a large mural of a city skyline at sunset on the package lockers.",
        "public_id": "019f394e-7389-7068-a1c5-7c8631098418",
        "storage_key": "property/6767906449166806/019f394e-7389-7068-a1c5-7c8631098418.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome residents and guests to the \"FORTYONE 11\" property with a striking mural on the package lockers, located near the mailboxes and building entrance.",
      "link": "",
      "alt_text": "The \"FORTYONE 11\" building entrance with a large mural of a city skyline at sunset on the package lockers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0bb09dd-6c77-47db-8c7b-bff33971aed1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-5500-732f-b419-d1decb482901.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with plush chairs, sofas, and a coffee table, overlooking a busy street through large windows.",
        "public_id": "019f394e-5500-732f-b419-d1decb482901",
        "storage_key": "property/6767906449166806/019f394e-5500-732f-b419-d1decb482901.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and large windows with views of the vibrant neighborhood.",
      "link": "",
      "alt_text": "Comfortable seating area with plush chairs, sofas, and a coffee table, overlooking a busy street through large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0656d99-7c27-416c-b562-fa5f4f3a3fac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-5333-74ed-8d43-79d8b103870b.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, punching bag, and shelving.",
        "public_id": "019f394e-5333-74ed-8d43-79d8b103870b",
        "storage_key": "property/6767906449166806/019f394e-5333-74ed-8d43-79d8b103870b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with cardio machines, strength training equipment, and a boxing station to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, punching bag, and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c70c841e-2941-47a5-86a7-fa82f2058521",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-55a3-7150-9b8c-537d030fc188.webp",
      "image_media": {
        "alt_text": "Lobby area with modern seating and a reception desk at Fortyone 11.",
        "public_id": "019f394e-55a3-7150-9b8c-537d030fc188",
        "storage_key": "property/6767906449166806/019f394e-55a3-7150-9b8c-537d030fc188.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome guests in the stylish lobby of Fortyone 11, featuring comfortable seating, a sleek reception desk, and large windows overlooking the street.",
      "link": "",
      "alt_text": "Lobby area with modern seating and a reception desk at Fortyone 11.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fa04a23-2d15-4b25-9ce0-c90babed88c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-31e0-76c1-9197-c7e0385d736f.webp",
      "image_media": {
        "alt_text": "Coffee bar with dispenser and supplies next to elevator lobby.",
        "public_id": "019f394e-31e0-76c1-9197-c7e0385d736f",
        "storage_key": "property/6767906449166806/019f394e-31e0-76c1-9197-c7e0385d736f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee at our convenient coffee bar, located near the elevator lobby for a quick pick-me-up.",
      "link": "",
      "alt_text": "Coffee bar with dispenser and supplies next to elevator lobby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4da0564-3478-410a-b628-b691b47d6c45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-1ba8-76d4-b38b-9d86c9311cfb.webp",
      "image_media": {
        "alt_text": "Interior hallway with mailboxes and a dog sculpture.",
        "public_id": "019f394e-1ba8-76d4-b38b-9d86c9311cfb",
        "storage_key": "property/6767906449166806/019f394e-1ba8-76d4-b38b-9d86c9311cfb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Modern apartment hallway featuring mailboxes, an elevator, and a decorative dog sculpture.",
      "link": "",
      "alt_text": "Interior hallway with mailboxes and a dog sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adc665e5-4e4f-4936-83ab-490c25cbc94f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0d46-73d2-9f57-c4e2446af74a.webp",
      "image_media": {
        "alt_text": "Gym equipment including treadmills, stationary bikes, weight benches, and a punching bag.",
        "public_id": "019f394e-0d46-73d2-9f57-c4e2446af74a",
        "storage_key": "property/6767906449166806/019f394e-0d46-73d2-9f57-c4e2446af74a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio machines, free weights, and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym equipment including treadmills, stationary bikes, weight benches, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02752621-df9f-46f2-aeba-2d63d7022c75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-e1ae-7739-8b35-6fbd57356bd9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, dumbbells, weight machines, and a punching bag.",
        "public_id": "019f394d-e1ae-7739-8b35-6fbd57356bd9",
        "storage_key": "property/6767906449166806/019f394d-e1ae-7739-8b35-6fbd57356bd9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and strength training equipment for an invigorating workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, dumbbells, weight machines, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1efe5cb6-bea3-476a-85e1-85d0c8bf9bce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-c54b-707d-8955-675f2a450c2d.webp",
      "image_media": {
        "alt_text": "Gym with weight bench, barbell, and cable machine.",
        "public_id": "019f394d-c54b-707d-8955-675f2a450c2d",
        "storage_key": "property/6767906449166806/019f394d-c54b-707d-8955-675f2a450c2d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a weight bench, barbell, and a comprehensive cable machine for a complete workout.",
      "link": "",
      "alt_text": "Gym with weight bench, barbell, and cable machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80c9cbd5-9654-4d80-8100-3e14ed93a8e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-c3c5-7564-8b1e-c2e0759f5f34.webp",
      "image_media": {
        "alt_text": "Lounge area with comfortable seating and a kitchenette.",
        "public_id": "019f394d-c3c5-7564-8b1e-c2e0759f5f34",
        "storage_key": "property/6767906449166806/019f394d-c3c5-7564-8b1e-c2e0759f5f34.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, complete with comfortable seating and a convenient kitchenette.",
      "link": "",
      "alt_text": "Lounge area with comfortable seating and a kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8baeed1a-2bbe-4135-b53d-0eac0d82148a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-54ee-706e-a6a3-76d6d9acd148.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with wood-grain cabinets, white countertop, and sink. A large mirror reflects a patterned shower curtain.",
        "public_id": "019d02d1-54ee-706e-a6a3-76d6d9acd148",
        "storage_key": "property/6767906449166806/019d02d1-54ee-706e-a6a3-76d6d9acd148.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious vanity with ample storage, a sleek sink, and a large mirror. The geometric shower curtain adds a stylish touch.",
      "link": "",
      "alt_text": "Modern bathroom vanity with wood-grain cabinets, white countertop, and sink. A large mirror reflects a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_720add2c-bbc5-42ee-8044-ed405ab5270e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-551d-77fd-8654-886381f0784a.webp",
      "image_media": {
        "alt_text": "Cozy living room with gray sectional sofa, decorative pillows, and a modern floor lamp.",
        "public_id": "019d02d1-551d-77fd-8654-886381f0784a",
        "storage_key": "property/6767906449166806/019d02d1-551d-77fd-8654-886381f0784a.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, featuring plush seating and stylish decor.",
      "link": "",
      "alt_text": "Cozy living room with gray sectional sofa, decorative pillows, and a modern floor lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0655288a-76d6-4046-81f3-be713044bfb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-43cf-775c-9248-10c7b195a480.webp",
      "image_media": {
        "alt_text": "A neatly made bed with blue and plaid pillows, and a brown headboard.",
        "public_id": "019d02d1-43cf-775c-9248-10c7b195a480",
        "storage_key": "property/6767906449166806/019d02d1-43cf-775c-9248-10c7b195a480.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy bedroom with a plush bed, featuring decorative pillows and a stylish headboard, perfect for relaxation.",
      "link": "",
      "alt_text": "A neatly made bed with blue and plaid pillows, and a brown headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3916a7a-5286-407e-a025-c9f96f627f71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-41a5-768a-8efb-a02c37565b03.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, bedside tables with lamps, and a closet.",
        "public_id": "019d02d1-41a5-768a-8efb-a02c37565b03",
        "storage_key": "property/6767906449166806/019d02d1-41a5-768a-8efb-a02c37565b03.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience comfort in our beautifully appointed bedrooms, featuring plush bedding and stylish decor for a restful retreat.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, bedside tables with lamps, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_831b7713-2649-46d7-adb4-b89d6866fdfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-390c-721c-879f-c25c7dfb7c01.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, two nightstands, and wall art.",
        "public_id": "019d02d1-390c-721c-879f-c25c7dfb7c01",
        "storage_key": "property/6767906449166806/019d02d1-390c-721c-879f-c25c7dfb7c01.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy and modern bedroom featuring a king-size bed with plush bedding, elegant nightstands, and tasteful wall decor. A perfect retreat for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, two nightstands, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91842e6b-56a3-4660-8da7-76d729b51fc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-37e5-76f6-93d7-5165e694389e.webp",
      "image_media": {
        "alt_text": "A stylish living room with a gray sofa, decorative pillows, and modern art reflected in a hanging mirror.",
        "public_id": "019d02d1-37e5-76f6-93d7-5165e694389e",
        "storage_key": "property/6767906449166806/019d02d1-37e5-76f6-93d7-5165e694389e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience modern living with this chic living space, featuring a comfortable gray sofa and contemporary art, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "A stylish living room with a gray sofa, decorative pillows, and modern art reflected in a hanging mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08607c46-6037-465d-8a1f-1495804abb2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-2e2e-73f9-927c-16bd0d1aad3f.webp",
      "image_media": {
        "alt_text": "Stylish entryway with a fiddle leaf fig plant, round mirror, and console table.",
        "public_id": "019d02d1-2e2e-73f9-927c-16bd0d1aad3f",
        "storage_key": "property/6767906449166806/019d02d1-2e2e-73f9-927c-16bd0d1aad3f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Welcome guests into your new home with this beautifully designed entryway, featuring a large fiddle leaf fig plant and a chic console table with decorative accents.",
      "link": "",
      "alt_text": "Stylish entryway with a fiddle leaf fig plant, round mirror, and console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17a8111e-019f-4203-8121-02fd4f669e17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-2b45-72de-95ce-6cd7224e96ba.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets.",
        "public_id": "019d02d1-2b45-72de-95ce-6cd7224e96ba",
        "storage_key": "property/6767906449166806/019d02d1-2b45-72de-95ce-6cd7224e96ba.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a sleek countertop. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a1d44f7-8b1c-4bd6-b9aa-2c2646f12c6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-23a1-742c-93fb-1f21b6d57e78.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sectional sofa, coffee table, and open-concept kitchen.",
        "public_id": "019d02d1-23a1-742c-93fb-1f21b6d57e78",
        "storage_key": "property/6767906449166806/019d02d1-23a1-742c-93fb-1f21b6d57e78.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a spacious living area seamlessly connected to a modern, open-concept kitchen.",
      "link": "",
      "alt_text": "Modern living room with a gray sectional sofa, coffee table, and open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ab9c8f2-50c1-44cf-91d9-dfe3e45c0ae9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-1fe3-7544-aa8d-883ec31490c5.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sectional sofa, ottoman, armchair, and large windows.",
        "public_id": "019d02d1-1fe3-7544-aa8d-883ec31490c5",
        "storage_key": "property/6767906449166806/019d02d1-1fe3-7544-aa8d-883ec31490c5.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable gray sectional sofa, decorative ottoman, and a cozy armchair, perfect for relaxation. Large windows flood the space with natural light.",
      "link": "",
      "alt_text": "Modern living room with gray sectional sofa, ottoman, armchair, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d713221b-bb3f-4e87-a6fd-336fe429e271",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Eem - Thai BBQ & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "3808 N Williams Ave #127, Portland, OR 97227, USA",
      "poi_short_description": "Modern Thai eatery serving creative BBQ and craft cocktails including tiki drinks in traditional mugs.",
      "poi_long_description": "Diners like this restaurant's unique Thai and Texas BBQ fusion dishes, especially the white curry with brisket burnt ends and the flavorful fried chicken. They also highlight the creative cocktails served in fun glassware and the lively, inviting atmosphere. Guests mention the friendly, attentive staff and appreciate the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7314-733f-a7f9-161cb3afd514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7314-733f-a7f9-161cb3afd514",
        "storage_key": "property/6767906449166806/01a0b552-7314-733f-a7f9-161cb3afd514.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.eempdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677422174665807613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eem---thai-bbq--cocktails",
      "poi_latitude": "45.5506551",
      "poi_longitude": "-122.6665212",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 971-295-1645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa08KlqnlVQR_ZZx1jEcTYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_71d170fb-d3ac-4e42-90c0-8dc506babe4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alberta cARTS",
      "poi_type": "Restaurants",
      "poi_address": "1027 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-783e-70c8-9dd9-19fc0ff8c9bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-783e-70c8-9dd9-19fc0ff8c9bf",
        "storage_key": "property/6767906449166806/01a0b552-783e-70c8-9dd9-19fc0ff8c9bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.albertacarts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10962256516576778405&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alberta-carts",
      "poi_latitude": "45.5592054",
      "poi_longitude": "-122.6548465",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-816-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTrRwNGnlVQRpRhFpzjCIZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_a7e5f1e4-4659-4a97-a64e-621169b89bde",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Bye and Bye",
      "poi_type": "Restaurants",
      "poi_address": "1011 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "Artful, dimly lit hipster bar with expansive patio serving Southern-inspired vegan food until late.",
      "poi_long_description": "People say this vegan restaurant offers a wide variety of delicious food, including popular items like the meatball sub, mac and cheese, and pretzel knots with beer cheese. They also highlight the great drinks, reasonable prices, and the lively, friendly atmosphere. Visitors appreciate the attentive staff and the ample indoor and outdoor seating, including dog-friendly patio options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-783e-70c8-9dd9-14637ec01b2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-783e-70c8-9dd9-14637ec01b2c",
        "storage_key": "property/6767906449166806/01a0b552-783e-70c8-9dd9-14637ec01b2c.webp",
        "width": 954,
        "height": 1188
      },
      "poi_business_url": "http://www.thebyeandbye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6431276954874198862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bye-and-bye",
      "poi_latitude": "45.559308",
      "poi_longitude": "-122.6552126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-9664-7578-a4ef-0c8d94d5f12c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b552-9664-7578-a4ef-0c8d94d5f12c",
        "storage_key": "property/6767906449166806/01a0b552-9664-7578-a4ef-0c8d94d5f12c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMz74ExmnlVQRTrtu61B8QFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_568193a5-98d0-40ae-b89d-69c9c0d64902",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Tin Shed Garden Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1438 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "Small, dog-friendly place specializing in American food, offering a covered patio & a canine menu.",
      "poi_long_description": "Diners like this cafe's delicious and hearty breakfast and brunch offerings, including perfectly cooked eggs, crispy biscuits, and flavorful gravies, with many gluten-free and vegetarian options available. They also highlight the friendly and attentive staff, as well as the cozy and welcoming atmosphere. Visitors appreciate the self-serve coffee and water station, and that the cafe is very dog-friendly, even offering a special menu for pups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7334-718b-a047-b1e4e2fb0206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7334-718b-a047-b1e4e2fb0206",
        "storage_key": "property/6767906449166806/01a0b552-7334-718b-a047-b1e4e2fb0206.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.tinshedgardencafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2211391378065780811&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tin-shed-garden-cafe",
      "poi_latitude": "45.558964",
      "poi_longitude": "-122.6508762",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-288-6966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3XIOh-nlVQRS_D47L1wsB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c3e1887f-7d8f-4443-94cb-da62c76543c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Pasture PDX",
      "poi_type": "Restaurants",
      "poi_address": "1413 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this sandwich shop's delicious and unique sandwiches, highlighting the quality ingredients, especially the meat and crispy bread. They also mention the generous portions, with sandwiches often large enough for two meals. Guests appreciate the friendly, homey vibe and the clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7db5-71af-b132-53df225560bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7db5-71af-b132-53df225560bb",
        "storage_key": "property/6767906449166806/01a0b552-7db5-71af-b132-53df225560bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pasturepdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2197673553665637299&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pasture-pdx",
      "poi_latitude": "45.5592966",
      "poi_longitude": "-122.6514598",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9a-sYaOnlVQRs7uCCnS0fx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e91f6a66-017e-4b26-816f-12cc299ae6d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alma",
      "poi_type": "Restaurants",
      "poi_address": "5237 NE Martin Luther King Jr Blvd, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this restaurant's delicious and flavorful Balkan dishes, with many highlighting the lamb shank, Adana kebab, and various dips. They also mention the warm, inviting atmosphere and the friendly, attentive, and knowledgeable staff. Guests appreciate the \"all you can enjoy\" tasting menu, noting it offers great value and a chance to try many dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7e3a-7554-9e35-948ae9cb1a9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7e3a-7554-9e35-948ae9cb1a9a",
        "storage_key": "property/6767906449166806/01a0b552-7e3a-7554-9e35-948ae9cb1a9a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.almapdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16764731149483107093&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alma",
      "poi_latitude": "45.5612491",
      "poi_longitude": "-122.6618571",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 971-313-9730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEXTw6WynlVQRFePdNyhKqOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f402b8bd-111d-4990-a2de-67510bbffb4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Shopping & Retail",
      "poi_address": "5055 NE Martin Luther King Jr Blvd, Portland, OR 97211, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "People say this grocery store offers great prices on groceries, especially when compared to other stores like Whole Foods and New Seasons. They also highlight the excellent value for money on their favorite items.\n\nSome reviews mention the bulk items can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-782e-71cc-af8d-b0956c22aa30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-782e-71cc-af8d-b0956c22aa30",
        "storage_key": "property/6767906449166806/01a0b552-782e-71cc-af8d-b0956c22aa30.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/portland-mlk",
      "poi_directions_map_url": "https://maps.google.com/?cid=1377338862249907116&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "45.5596812",
      "poi_longitude": "-122.6617662",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-208-4823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca46-74d6-b12b-179f7878660c",
        "storage_key": "property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-M2DxqnlVQRrBO_02VKHRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a4e1d935-32aa-421f-b1d7-4e49be9e4b07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alberta Co-op Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "This grocery cooperative with a farmer's-market vibe features organic produce & many bulk items.",
      "poi_long_description": "People say this grocery store offers a wide selection of local and organic products, including fresh produce, bulk spices, and unique items. They also highlight the friendly and helpful staff, who provide excellent service. Visitors appreciate the convenient hours and the value found in bulk purchase options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7837-7729-a07e-ea6274e731b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7837-7729-a07e-ea6274e731b1",
        "storage_key": "property/6767906449166806/01a0b552-7837-7729-a07e-ea6274e731b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alberta.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10852982040076854941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alberta-co-op-grocery",
      "poi_latitude": "45.5589714",
      "poi_longitude": "-122.6494217",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-287-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca46-74d6-b12b-179f7878660c",
        "storage_key": "property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6q4FB-nlVQRnaZ59KmJnZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b56b3a01-c906-4ee0-a2c3-208355dd7c07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Proud Mary Cafe",
      "poi_type": "Shopping & Retail",
      "poi_address": "2012 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "Hip Aussie-style cafe in an industrial-chic space offering craft coffee, breakfast & smoothies.",
      "poi_long_description": "Diners like this cafe's delicious and creative brunch dishes, with the avocado toast, ricotta pancakes, and potato hash being popular choices. They also highlight the exceptional coffee, including specialty pour-overs and Australian-style brews. Guests mention the warm, lively atmosphere and friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-733f-74de-b482-f18f74ffeb88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-733f-74de-b482-f18f74ffeb88",
        "storage_key": "property/6767906449166806/01a0b552-733f-74de-b482-f18f74ffeb88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.proudmarycoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17324691347336370546&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "proud-mary-cafe",
      "poi_latitude": "45.5589512",
      "poi_longitude": "-122.6444893",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-208-3475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-9669-773f-8b8b-8debdccf0b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b552-9669-773f-8b8b-8debdccf0b5a",
        "storage_key": "property/6767906449166806/01a0b552-9669-773f-8b8b-8debdccf0b5a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJC4lfHCCnlVQRcplEgf2qbfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_6e40c52f-8aaa-40be-b10d-e4cd850e97b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Portland Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "602 NE Prescott St, Portland, OR 97211, USA",
      "poi_short_description": "Converted Baptist church now used as an intimate performing arts theater with free beer.",
      "poi_long_description": "People say this theater offers creative and professionally done performances with talented actors, as well as comfortable seating. They also highlight the intimate atmosphere and the availability of snacks, drinks, and a free water station. Guests mention the clean restrooms and helpful staff who provide special seating accommodations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-7c29-761e-9264-fed0d6868d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-7c29-761e-9264-fed0d6868d0c",
        "storage_key": "property/6767906449166806/01a0b552-7c29-761e-9264-fed0d6868d0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.portlandplayhouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9762447441775015123&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "portland-playhouse",
      "poi_latitude": "45.5553367",
      "poi_longitude": "-122.6593975",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-488-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiz_bwxenlVQR07RrgTkue4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_37a56c11-c133-4a72-8b6c-82645eccd2e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alberta Abbey",
      "poi_type": "Entertainment",
      "poi_address": "126 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "Popular event venue and arts center for burlesque shows, as well as a place to see live music.",
      "poi_long_description": "Visitors say this performing arts venue offers a variety of entertaining shows, including live music, comedy, and burlesque, with many highlighting the talented performers. They also mention the intimate atmosphere, comfortable seating, and the availability of reasonably priced drinks and snacks. Guests appreciate the friendly and professional staff, who ensure a well-organized and enjoyable experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-84b8-7277-b79a-e27b348122ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-84b8-7277-b79a-e27b348122ba",
        "storage_key": "property/6767906449166806/01a0b552-84b8-7277-b79a-e27b348122ba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.albertaabbey.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=899999881879453412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alberta-abbey",
      "poi_latitude": "45.55889860000001",
      "poi_longitude": "-122.6639037",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy1xDxhCnlVQR5H5RyR9xfQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52702943-25f9-4f5a-a1d8-b61f10945034",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alberta Street Pub",
      "poi_type": "Entertainment",
      "poi_address": "1036 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "Old-school watering hole with live music, a covered patio & a menu of classic comfort foods.",
      "poi_long_description": "People say this pub offers fantastic live music, a wide variety of drinks, and good food like fish and chips, catfish, and shrimp. They also highlight the welcoming atmosphere, affordable happy hour, and spacious heated outdoor patio.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-80d4-777e-9c77-6c4db9c57e6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-80d4-777e-9c77-6c4db9c57e6c",
        "storage_key": "property/6767906449166806/01a0b552-80d4-777e-9c77-6c4db9c57e6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.albertastreetpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5167035604527599758&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alberta-street-pub",
      "poi_latitude": "45.5589313",
      "poi_longitude": "-122.6548335",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-284-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-9664-7578-a4ef-0c8d94d5f12c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b552-9664-7578-a4ef-0c8d94d5f12c",
        "storage_key": "property/6767906449166806/01a0b552-9664-7578-a4ef-0c8d94d5f12c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzjzFxmnlVQRjtCplYH_tEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_4356b133-8352-4ec1-9ff4-70fc5e5aeb69",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Irving Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "707 NE Fremont St, Portland, OR 97212, USA",
      "poi_short_description": "Grassy area on land originally owned by a sea captain offering a dog park & sports courts.",
      "poi_long_description": "People say this park offers wide open green spaces, lots of shade, and various sports fields, including baseball, basketball, and tennis courts. They also highlight the splash area for children and the accessible, clean restrooms. Visitors appreciate the quiet atmosphere, making it ideal for relaxing or enjoying time outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-8336-77a7-a29c-932a2921ff0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-8336-77a7-a29c-932a2921ff0d",
        "storage_key": "property/6767906449166806/01a0b552-8336-77a7-a29c-932a2921ff0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portlandoregon.gov/parks/finder/index.cfm?action=ViewPark&PropertyID=195",
      "poi_directions_map_url": "https://maps.google.com/?cid=8316342831477897854&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "irving-park",
      "poi_latitude": "45.5473007",
      "poi_longitude": "-122.656689",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-823-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-d73d-714a-9d3f-7167633c32e7",
        "storage_key": "property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUa4nTmnlVQRfjqbTL6VaXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c9cba17f-a3c0-4d08-aa73-e053e7d3890f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Dr. Martin Luther King, Jr. School Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4906 NE 6th Ave, Portland, OR 97211, USA",
      "poi_short_description": "City park with picnic facilities, a playground, walking track, athletic fields, and dog park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-82eb-704a-8784-6027fc30309d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-82eb-704a-8784-6027fc30309d",
        "storage_key": "property/6767906449166806/01a0b552-82eb-704a-8784-6027fc30309d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.portland.gov/parks/king-school-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9870428017633009206&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-martin-luther-king-jr-school-park",
      "poi_latitude": "45.5573837",
      "poi_longitude": "-122.6600141",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-d73d-714a-9d3f-7167633c32e7",
        "storage_key": "property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKU5FehenlVQRNh4UfPzN-og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_01777d9b-a61d-4e02-b8e4-fea8171b03c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Alberta Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1905 NE Killingsworth St, Portland, OR 97211, USA",
      "poi_short_description": "Public green space with sport courts & fields, a playground, picnic tables & an off-leash dog area.",
      "poi_long_description": "People say this park features numerous play structures for children of all ages, along with covered basketball courts and fenced-in tennis courts. Visitors also highlight the abundant shade from tall trees, making it ideal for picnics and relaxation. They also mention the well-maintained walking paths and available restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-85ee-715a-bb08-b7f813f9cd04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-85ee-715a-bb08-b7f813f9cd04",
        "storage_key": "property/6767906449166806/01a0b552-85ee-715a-bb08-b7f813f9cd04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.portlandonline.com/parks/finder/index.cfm?action=ViewPark&PropertyID=49&PropertyID_new_value=false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8618835721877156821&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alberta-park",
      "poi_latitude": "45.5644753",
      "poi_longitude": "-122.6451045",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-d73d-714a-9d3f-7167633c32e7",
        "storage_key": "property/6767906449166806/019d02d1-d73d-714a-9d3f-7167633c32e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaUIa1-OmlVQR1XPvq2xBnHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_80c3cf73-33f1-41e6-ad19-f8e86013d457",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "ZoomCare Alberta - Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 NE Alberta St, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-846a-772c-a1b0-bb7e50b6e08b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-846a-772c-a1b0-bb7e50b6e08b",
        "storage_key": "property/6767906449166806/01a0b552-846a-772c-a1b0-bb7e50b6e08b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-alberta-street?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=alberta",
      "poi_directions_map_url": "https://maps.google.com/?cid=4568750154913191394&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zoomcare-alberta---urgent-care--primary-care",
      "poi_latitude": "45.5589547",
      "poi_longitude": "-122.6515095",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTc7KLh-nlVQR4pUcQw92Zz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_901ce863-e072-4132-ab0a-b7f7df72dae7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Legacy Emanuel Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "501 N Graham St, Portland, OR 97227, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-8af8-7618-9ce2-5406a6da2aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-8af8-7618-9ce2-5406a6da2aef",
        "storage_key": "property/6767906449166806/01a0b552-8af8-7618-9ce2-5406a6da2aef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-emanuel-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5997193270814938280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legacy-emanuel-medical-center",
      "poi_latitude": "45.5441119",
      "poi_longitude": "-122.6694547",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-413-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-d07c-700d-87b9-bca9dbd4c0fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-d07c-700d-87b9-bca9dbd4c0fc",
        "storage_key": "property/6767906449166806/019d02d1-d07c-700d-87b9-bca9dbd4c0fc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-41IESnlVQRqJRJXIFPOlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_862f5ffe-23ed-4806-aff0-4d8d01ec0654",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "TriMet Bus Lines 6 / 72",
      "poi_type": "Transportation & Transit",
      "poi_address": "4111 NE Martin Luther King Jr Blvd, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10864119341522844993&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "4111-ne-martin-luther-king-jr-blvd",
      "poi_latitude": "45.553461299999995",
      "poi_longitude": "-122.6618489",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxC-HhanlVQRQX3rBPsaxZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b9d45de4-92fb-419d-ba7f-8cbb7cc17bd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "MAX Yellow – Overlook Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97227, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-89c6-71dd-b462-a28713036aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-89c6-71dd-b462-a28713036aae",
        "storage_key": "property/6767906449166806/01a0b552-89c6-71dd-b462-a28713036aae.webp",
        "width": 978,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/ride/m/stop.html?stop_id=11510",
      "poi_directions_map_url": "https://maps.google.com/?cid=1276034683955932954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "overlook-park",
      "poi_latitude": "45.548708999999995",
      "poi_longitude": "-122.681011",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-9667-72ef-b43a-8879f50c5381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b552-9667-72ef-b43a-8879f50c5381",
        "storage_key": "property/6767906449166806/01a0b552-9667-72ef-b43a-8879f50c5381.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRW_OWinlVQRGm9FyshitRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_47f7113d-4e97-4517-a469-89fdfafd022e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Martin Luther King Jr elementary",
      "poi_type": "Education",
      "poi_address": "4906 NE 6th Ave, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14380666574111267296&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "martin-luther-king-jr-elementary",
      "poi_latitude": "45.5580929",
      "poi_longitude": "-122.6589942",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmRAFFwChlVQR4Fk8nw5kksc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_862d6054-fa6b-4bd8-92ae-6277194cb0f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "University of Oregon Portland",
      "poi_type": "Education",
      "poi_address": "2800 NE Liberty St, Portland, OR 97211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-8c99-71f4-b4d6-65bb3742e452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-8c99-71f4-b4d6-65bb3742e452",
        "storage_key": "property/6767906449166806/01a0b552-8c99-71f4-b4d6-65bb3742e452.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pdx.uoregon.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5112223607005501888&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-oregon-portland",
      "poi_latitude": "45.5702923",
      "poi_longitude": "-122.6370007",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-412-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca9a-723e-b83c-b6644407c3f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca9a-723e-b83c-b6644407c3f5",
        "storage_key": "property/6767906449166806/019d02d1-ca9a-723e-b83c-b6644407c3f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4e2Fr8-nlVQRwNnt60hE8kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1d5f9029-aa93-443d-ae15-80a74705a58f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Kaiser Permanente Interstate Medical Office East",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3550 N Interstate Ave, Portland, OR 97227, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-8b58-76af-8a38-5a5d62b204c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b552-8b58-76af-8a38-5a5d62b204c5",
        "storage_key": "property/6767906449166806/01a0b552-8b58-76af-8a38-5a5d62b204c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/oregon-washington/facilities/Interstate-Medical-Office-East-100268",
      "poi_directions_map_url": "https://maps.google.com/?cid=17175030152572181398&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kaiser-permanente-interstate-medical-office-east",
      "poi_latitude": "45.5476196",
      "poi_longitude": "-122.6795489",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 800-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9faKWinlVQRlhuwMu32We4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a4db3563-078e-4b1f-889d-43828661593a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Portland Farmers Market - King",
      "poi_type": "Shopping & Retail",
      "poi_address": "NE Wygant St &, NE 7th Ave, Portland, OR 97211, USA",
      "poi_short_description": "This seasonal farmer's market open on Sundays hosts local produce & specialty-food vendors.",
      "poi_long_description": "People say this farmers market offers a great selection of fresh, locally grown produce, baked goods, and ready-to-eat meals like breakfast burritos. They also highlight the reasonable prices and the welcoming atmosphere for families, with picnic tables and a playground. Others also mention the live music and the variety of artisan goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e917-744c-86ff-88eea2921815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e917-744c-86ff-88eea2921815",
        "storage_key": "property/6767906449166806/01a0b558-e917-744c-86ff-88eea2921815.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portlandfarmersmarket.org/our-markets/king/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5327616952258944762&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "portland-farmers-market---king",
      "poi_latitude": "45.556939",
      "poi_longitude": "-122.6587106",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-241-0032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca9a-723e-b83c-b00a128eb197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca9a-723e-b83c-b00a128eb197",
        "storage_key": "property/6767906449166806/019d02d1-ca9a-723e-b83c-b00a128eb197.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfTQR1BmnlVQR-l6-ImR_70k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_6d96abb7-33e1-4a03-ad52-22c81c802018",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Hand & Stone Massage and Facial Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "4155 N Williams Ave, Portland, OR 97217, USA",
      "poi_short_description": "Massage, facial, and nail spa chain using hot and cold stones, plus micropeel treatments.",
      "poi_long_description": "People say this spa offers excellent massages and facials, with staff who are skilled at addressing specific concerns and providing personalized treatments. Visitors also highlight the professional and friendly staff, who create a relaxing and welcoming atmosphere. They also mention the clean facilities and the overall wonderful experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e5c2-7368-8a55-a541d4d51c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e5c2-7368-8a55-a541d4d51c95",
        "storage_key": "property/6767906449166806/01a0b558-e5c2-7368-8a55-a541d4d51c95.webp",
        "width": 512,
        "height": 512
      },
      "poi_business_url": "https://handandstone.com/locations/portland-ne/?utm_source=google&utm_medium=organic&utm_campaign=businesslisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=15348000434893638886&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hand--stone-massage-and-facial-spa",
      "poi_latitude": "45.55388",
      "poi_longitude": "-122.666982",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 971-501-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87N6uxWnlVQR5kxgDhQN_9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "custom_6e755c1e-8eef-4f1d-b856-db4cb3ac8b4d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Bodywork Balance",
      "poi_type": "Health and Wellness",
      "poi_address": "4046 NE Rodney Ave A, Portland, OR 97212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bodyworkbalance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072375995255595735&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bodywork-balance",
      "poi_latitude": "45.552762",
      "poi_longitude": "-122.664442",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 971-645-6347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-cfb8-72e4-99b7-3c69a8ad62e2",
        "storage_key": "property/6767906449166806/019d02d1-cfb8-72e4-99b7-3c69a8ad62e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyXBuFWhlVQR16KlhbBFoyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_0a921e8f-1628-4c62-aa52-33db89cabc1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Poa Café",
      "poi_type": "Restaurants",
      "poi_address": "4025 N Williams Ave, Portland, OR 97227, USA",
      "poi_short_description": "Counter-service place offering coffee & smoothies alongside heath-oriented brunch fare & bowls.",
      "poi_long_description": "Diners like this cafe's delicious and healthy food, including filling portions, fresh ingredients, and a wide variety of menu items for all dietary restrictions. They also highlight the friendly staff, upbeat yet relaxing atmosphere, and excellent coffee and smoothies.\n\nSome reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e6cb-71fe-a5ea-55f7d66a0bb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e6cb-71fe-a5ea-55f7d66a0bb4",
        "storage_key": "property/6767906449166806/01a0b558-e6cb-71fe-a5ea-55f7d66a0bb4.webp",
        "width": 1056,
        "height": 595
      },
      "poi_business_url": "http://poacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4138316212868416659&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "poa-caf",
      "poi_latitude": "45.5523833",
      "poi_longitude": "-122.6669083",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-954-1243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QSCeRWnlVQRkwRDfKtAbjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3d2b0b25-26e5-4eb6-9285-0d54db43f073",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "Cafe Olli",
      "poi_type": "Restaurants",
      "poi_address": "3925 NE Martin Luther King Jr Blvd, Portland, OR 97212, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this cafe's delicious and thoughtfully prepared food, including standout pizzas, baked eggs, and grits, with many items made from scratch. They also highlight the friendly and attentive staff, along with a warm and welcoming atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e902-712d-ae31-f5342bdf08b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e902-712d-ae31-f5342bdf08b3",
        "storage_key": "property/6767906449166806/01a0b558-e902-712d-ae31-f5342bdf08b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://littleolli.squarespace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17979143572119769062&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-olli",
      "poi_latitude": "45.55115809999999",
      "poi_longitude": "-122.6619115",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-206-8604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b552-9669-773f-8b8b-8debdccf0b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b552-9669-773f-8b8b-8debdccf0b5a",
        "storage_key": "property/6767906449166806/01a0b552-9669-773f-8b8b-8debdccf0b5a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJeaQuoUeFhVQR5k_yPdK_gvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_d1852123-7d7b-4218-a160-7d18cff742c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "the Celery",
      "poi_type": "Restaurants",
      "poi_address": "4008 N Williams Ave, Portland, OR 97227, USA",
      "poi_short_description": "Clean eatery providing grain bowls, smoothies and acai bowls, plus juices made with organic produce.",
      "poi_long_description": "People say this juice bar offers delicious, fresh, and organic juices, smoothies, and grain bowls, with many highlighting the quality ingredients. They also mention the reasonable prices and the clean, spacious dining area. Others appreciate the friendly and efficient staff, noting their helpfulness and positive attitude.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e5e7-7335-8441-a62ddffde2a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e5e7-7335-8441-a62ddffde2a4",
        "storage_key": "property/6767906449166806/01a0b558-e5e7-7335-8441-a62ddffde2a4.webp",
        "width": 1025,
        "height": 1280
      },
      "poi_business_url": "http://thecelery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17156750832597392086&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-celery",
      "poi_latitude": "45.5522085",
      "poi_longitude": "-122.6665565",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-841-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca8d-73cb-8e7f-1bf86f9d650b",
        "storage_key": "property/6767906449166806/019d02d1-ca8d-73cb-8e7f-1bf86f9d650b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw4zhw-OnlVQR1traXPsFGe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_325e6ee1-e4c1-4d7e-83b0-cde79aa29297",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "New Seasons Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3445 N Williams Ave, Portland, OR 97227, USA",
      "poi_short_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic, and local products, including a great bakery, hot bar, and deli. They also highlight the friendly and helpful staff, and the clean, well-maintained store.\n\nSome reviews mention the prices can be very high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e60b-71f6-8dae-9fe8ae983907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e60b-71f6-8dae-9fe8ae983907",
        "storage_key": "property/6767906449166806/01a0b558-e60b-71f6-8dae-9fe8ae983907.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.newseasonsmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15437073386178965484&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-seasons-market",
      "poi_latitude": "45.5480562",
      "poi_longitude": "-122.667343",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-528-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca46-74d6-b12b-179f7878660c",
        "storage_key": "property/6767906449166806/019d02d1-ca46-74d6-b12b-179f7878660c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnyFQvECnlVQR7G_VonSAO9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_89abe6a0-03fe-46b3-841c-d047f382e449",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "KairosPDX",
      "poi_type": "Education",
      "poi_address": "KairosPDX, 4915 N Gantenbein Ave, Portland, OR 97217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kairospdx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10700336967553999392&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kairospdx",
      "poi_latitude": "45.558482",
      "poi_longitude": "-122.6697",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-567-9820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-ca9a-723e-b83c-b6644407c3f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ca9a-723e-b83c-b6644407c3f5",
        "storage_key": "property/6767906449166806/019d02d1-ca9a-723e-b83c-b6644407c3f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6wLfz-nlVQRIGIJeMc7f5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10f65260-2c47-4ceb-a158-067f09467e12",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "WorkSource Portland Metro",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30 N Webster St # E, Portland, OR 97217, USA",
      "poi_short_description": "Employment agency where job seekers can access computers, Wi-Fi, and other resources.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-e5b1-72c8-b99d-79052afd0d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b558-e5b1-72c8-b99d-79052afd0d36",
        "storage_key": "property/6767906449166806/01a0b558-e5b1-72c8-b99d-79052afd0d36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://worksourceportlandmetro.org/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4781721676214703079&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "worksource-portland-metro",
      "poi_latitude": "45.5596653",
      "poi_longitude": "-122.6673864",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 503-280-6046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b558-f104-779c-9af3-c12e1f152584.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b558-f104-779c-9af3-c12e1f152584",
        "storage_key": "property/6767906449166806/01a0b558-f104-779c-9af3-c12e1f152584.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy8YGCBGnlVQR5xOQpYcWXEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "employment_agency"
    },
    {
      "id": "custom_c9042c4f-9846-4f1e-81c4-cb7162d4967e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "TriMet Bus Line 24",
      "poi_type": "Transportation & Transit",
      "poi_address": "3500 NE Martin Luther King Jr Blvd",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://trimet.org/#tracker/stop/1846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1490948709927297338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ne-fremont--m-l-king",
      "poi_latitude": "45.54821",
      "poi_longitude": "-122.66181700000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b59d-6ef0-7258-8674-251b4b558a1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b59d-6ef0-7258-8674-251b4b558a1a",
        "storage_key": "property/6767906449166806/01a0b59d-6ef0-7258-8674-251b4b558a1a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0M40zinlVQROiGLyfPpsBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_21805166-9de8-4771-a28c-d7a29d7b06fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "poi_name": "TriMet Bus Line 44",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Williams Ave & NE Skidmore St",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://trimet.org/#tracker/stop/6367",
      "poi_directions_map_url": "https://maps.google.com/?cid=16720646130097660705&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "n-williams--ne-skidmore",
      "poi_latitude": "45.55449",
      "poi_longitude": "-122.66664",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/01a0b59d-6ef0-7258-8674-251b4b558a1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b59d-6ef0-7258-8674-251b4b558a1a",
        "storage_key": "property/6767906449166806/01a0b59d-6ef0-7258-8674-251b4b558a1a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3X9yhWnlVQRISN7xxCrC-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d65d8914-c3f5-4707-90fe-87c53172b0fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_40940e4f-d540-45c7-8484-894c0483c6e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9bedc437-2554-4525-a226-81c4b0a5acda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1ce85583-c1ae-4d4c-af93-aaa2922da258",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_8b0a1495-ced0-4d3b-a6ef-506ce2322001",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_163f4d74-a64c-48cf-a470-3b33a4567a01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5.0",
      "name": "Colleen Brawley",
      "text": "Lee from maintenance was fantastic. I was pleasantly surprised at how quickly he responded, within a couple hours of submitting the requests Lee had everything totally resolved and operational. And he was so sweet and friendly the whole time, I loved his positive attitude and enthusiasm for getting the job done right. Thank you Lee!!!",
      "date": "2025-07-02",
      "title": ""
    },
    {
      "id": "custom_47724877-a4cd-4b44-89ea-6ac223573b7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5.0",
      "name": "Alafair Kionka",
      "text": "Lee from Maintenance was fantastic! He came the morning after I put in a request for help with setting up my AC unit and was so swift and professional. I appreciated how reachable he was and him letting me know to reach out if I needed anything else.",
      "date": "2025-07-08",
      "title": ""
    },
    {
      "id": "custom_5015e7f2-814e-4224-9529-9fed335e8de1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Adri Riddle",
      "text": "Terry, the leasing manager was exceptionally helpful with my entire process from accommodating a facetime virtual tour, generously answering all of my questions and being flexible with my move in date. Very kind and welcoming!",
      "date": "2026-09-09",
      "title": "false"
    },
    {
      "id": "custom_471c79ea-c009-45fe-9ea7-5ec54a73661d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Kati Dimoff",
      "text": "I've been here a month and everything is great so far. I love the apartment and everyone that works here is friendly and helpful. Patrick is the best and gets any maintenance done really quickly and has given me lots of good advice and I'm always happy to see him around the property. Terry is responsive and made my move easy!",
      "date": "2026-08-12",
      "title": "false"
    },
    {
      "id": "custom_dd7609a3-236b-490a-a036-103084ed73ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Mighty E",
      "text": "Terry has been an excellent property manager throughout the time I’ve lived here. He’s always been helpful, attentive, and quick to address any questions or concerns I’ve had. He’s available during office hours and genuinely does his best to support the residents. I also appreciate the effort he puts into creating monthly community events.",
      "date": "2026-07-17",
      "title": "false"
    },
    {
      "id": "custom_dfb218f8-b5a2-4a93-94bc-81f724427202",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Johnisha Watlington",
      "text": "Terry was amazing from the moment I walked through the door! I arrived just before the office closed, and he still took the time to give me a full tour and answer every one of my questions without making me feel rushed. His professionalism, patience, and willingness to help made for an excellent experience. I truly appreciate the outstanding customer service!",
      "date": "2026-07-09",
      "title": "false"
    },
    {
      "id": "custom_96939d95-0663-4a95-964f-58757624ca7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Crystal Watson",
      "text": "I had the maintenance man helped me today with some maintenance request that I put in his name is Patrick at 4111. He was so helpful and I appreciate him so much thank you for allowing him to be of service to me and I am disabled and I really needed the help with the air conditioner. He did a wonderful job. Thank you. Have a great day.",
      "date": "2026-07-16",
      "title": "false"
    },
    {
      "id": "custom_2bed52f5-b6de-4cac-a2f1-e5e5387e3366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Conner Roth",
      "text": "Terry was very helpful through my entire move in process.",
      "date": "2026-06-16",
      "title": "false"
    },
    {
      "id": "custom_b616cb38-7dbd-469d-927d-7bb1e6cfa4b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "rating": "5",
      "name": "Kyla Smith",
      "text": "I had a great experience working with Terry! He took the time to show me around an apartment and walk me through the layout, answering all of my questions along the way. He was professional, knowledgeable, and very easy to talk to. You can tell he genuinely cares about helping people find the right fit and making the process smooth. I really appreciated his communication and attention to detail. I would definitely recommend Terry to anyone looking for a property manager who is friendly, responsive, and truly helpful!",
      "date": "2026-05-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_47c9e726-13eb-4ff2-8499-1cf5b0220fea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-bcd0-765a-a989-1b84e8f4d71c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Lobby with reception desk and seating area",
        "public_id": "019d20b7-bcd0-765a-a989-1b84e8f4d71c",
        "storage_key": "property/6767906449166806/019d20b7-bcd0-765a-a989-1b84e8f4d71c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "FortyOne11 Lobby & Gym",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qsjggNxLTJ1"
    },
    {
      "id": "custom_a0866c31-51bf-4761-8bfe-006d0f33788f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-5501-77d7-8c2a-884c0cd2a158.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with large windows and city view",
        "public_id": "019d02d2-5501-77d7-8c2a-884c0cd2a158",
        "storage_key": "property/6767906449166806/019d02d2-5501-77d7-8c2a-884c0cd2a158.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA - 513 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mLHEVLAxnKY"
    },
    {
      "id": "custom_23e8a497-df5a-4fb8-90b1-2a448677abb2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-f400-716e-ab91-fb45f16c0f89.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with yellow sofa, coffee table, and large window.",
        "public_id": "019d02d2-f400-716e-ab91-fb45f16c0f89",
        "storage_key": "property/6767906449166806/019d02d2-f400-716e-ab91-fb45f16c0f89.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 931 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5ntBu7j3Fq1"
    },
    {
      "id": "custom_397c3960-7b83-49c1-a582-a3e85acdd71f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-f403-77cf-ad57-31ce17f4fc23.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with a gray sectional sofa, coffee table, and modern kitchen cabinets.",
        "public_id": "019d02d2-f403-77cf-ad57-31ce17f4fc23",
        "storage_key": "property/6767906449166806/019d02d2-f403-77cf-ad57-31ce17f4fc23.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BA, 1BA 515SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZcsxRibkuYb"
    },
    {
      "id": "custom_72d6928f-c8f5-4c83-85d8-6bf6d5348d16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-6314-73ec-b533-b7f8a2292b0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space.",
        "public_id": "019d02d2-6314-73ec-b533-b7f8a2292b0b",
        "storage_key": "property/6767906449166806/019d02d2-6314-73ec-b533-b7f8a2292b0b.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Studio, 1BA 402SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o1m6uMv55hi"
    },
    {
      "id": "custom_97030d1c-edfd-4be5-be91-f0f4a518eda4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-f8d3-75cd-8326-907fa9fa2165.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space.",
        "public_id": "019d02d2-f8d3-75cd-8326-907fa9fa2165",
        "storage_key": "property/6767906449166806/019d02d2-f8d3-75cd-8326-907fa9fa2165.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 BR, 1 BA 515SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wFh8vPxfyyW"
    },
    {
      "id": "custom_e3efd37c-df6f-48ca-bd30-e4d0882a92dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-654f-737c-bdfd-15b7ab1484cc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with large windows offering city views.",
        "public_id": "019d02d2-654f-737c-bdfd-15b7ab1484cc",
        "storage_key": "property/6767906449166806/019d02d2-654f-737c-bdfd-15b7ab1484cc.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA 513SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XnAr3eMa9z3"
    },
    {
      "id": "custom_04293639-9f5f-4cf3-80af-cdaa2434babb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d2-6ab2-70cb-ad18-724f8a66aa40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with large windows and hardwood floors.",
        "public_id": "019d02d2-6ab2-70cb-ad18-724f8a66aa40",
        "storage_key": "property/6767906449166806/019d02d2-6ab2-70cb-ad18-724f8a66aa40.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "2BR, 1BA 913SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Hmkd31yFnWP"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa4c3-158c-77ee-812b-4161586fd473",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "FortyOne 11 Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "portland-or-apartments-in-unit-washer-dryer",
      "search_query": "apartments with in-unit washer and dryer in Portland OR",
      "category": "Amenity",
      "h1_title": "Apartments with Washer & Dryer in Portland, OR",
      "h2_subtitle": "Discover premier living at FortyOne 11 in Portland, OR. Enjoy the comfort of in-unit washer and dryer facilities and elevate your lifestyle experience.",
      "page_copy": "Welcome to FortyOne 11, where modern living meets convenience in Portland, OR. Our spacious apartments come equipped with in-unit washers and dryers, allowing you to enjoy the ease of doing laundry in the comfort of your own home. Located in the vibrant King neighborhood, FortyOne 11 offers more than just a place to live—it's a lifestyle upgrade. \n\nBeyond the convenience of laundry at home, our community boasts various amenities. Enjoy vaulted ceilings that create an open and airy atmosphere. Stay fit in our fitness center complete with cardio machines and free weights. Plus, with package lockers and gated parking, we ensure your needs are met with security and comfort in mind. Discover why FortyOne 11 is the ideal choice for those seeking apartments with in-unit washer and dryer in Portland, OR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer & Dryer in Portland, OR",
      "seo_description": "Experience easy living with in-unit washer & dryer at FortyOne 11 in Portland, OR. Discover our amenities and vibrant King neighborhood location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "king-portland-gated-parking-apartments",
      "search_query": "gated parking apartments in King Portland",
      "category": "Amenity",
      "h1_title": "Gated Parking Apartments in King, Portland",
      "h2_subtitle": "FortyOne 11 offers gated parking and a secure environment. Discover your ideal home in the King neighborhood, Portland.",
      "page_copy": "Located in the heart of King, Portland, FortyOne 11 provides secure and convenient living with our gated parking feature. Here, you can relax knowing your vehicle is safe within our off-street parking facilities. Our community combines comfort and security in a vibrant neighborhood setting. \n\nIn addition to gated parking, our apartments boast an array of impressive amenities. Enjoy the luxury of vaulted ceilings and a state-of-the-art fitness center equipped with cardio machines and free weights. For cooking enthusiasts, our kitchens come complete with a gas stovetop and oven. At FortyOne 11, package lockers are also available, making it easy and secure to receive deliveries. Experience superior living with gated parking at FortyOne 11 in King, Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Parking Apartments in King, Portland",
      "seo_description": "Secure a spot at FortyOne 11 with gated parking, where comfort meets convenience in King, Portland. Explore our amenities and vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "multnomah-county-energy-efficient-appliances",
      "search_query": "energy-efficient stainless-steel appliances Multnomah County",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Appliances in Multnomah County",
      "h2_subtitle": "Discover energy-efficient living at FortyOne 11. Enjoy stainless-steel appliances in Portland's Multnomah County.",
      "page_copy": "FortyOne 11 in Multnomah County is the perfect destination for those seeking modern amenities and energy efficiency. Our apartments are equipped with energy-efficient stainless-steel appliances, making it easier for you to maintain an eco-friendly lifestyle while enjoying contemporary design and functionality. Located in the vibrant King neighborhood, these homes provide a stylish and efficient living environment.\n\nLiving at FortyOne 11 means more than just top-of-the-line appliances. Our community offers features like vaulted ceilings and a full fitness center, complete with cardio equipment and free weights. Enjoy the convenience of secure package lockers and gated parking that ensures peace of mind. Embrace a greener and more modern way of living with energy-efficient stainless-steel appliances in Multnomah County at FortyOne 11.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Appliances in Multnomah County",
      "seo_description": "Live sustainably at FortyOne 11 in Multnomah County with energy-efficient stainless-steel appliances. Explore our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "northeast-portland-apartments-quartz-countertops",
      "search_query": "apartments with quartz countertops in Northeast Portland",
      "category": "Amenity",
      "h1_title": "Apartments with Quartz Countertops in NE Portland",
      "h2_subtitle": "Elevate your living experience at FortyOne 11. Enjoy stylish quartz countertops in Northeast Portland's vibrant community.",
      "page_copy": "At FortyOne 11, located in the heart of Northeast Portland, discover the exquisite touch of quartz countertops in our modern apartments. These elegant surfaces add a sense of luxury and refinement to your home, combining durability with style. Nestled in the lively King neighborhood, our community offers the perfect blend of comfort and sophistication.\n\nOur residents enjoy more than just beautiful countertops. With vaulted ceilings and a fully equipped fitness center featuring cardio machines and free weights, our amenities cater to a wide range of lifestyle preferences. We also offer convenient package lockers and secured, off-street parking. Experience modern living redefined with quartz countertops and a vibrant community environment at FortyOne 11 in Northeast Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Quartz Countertops in NE Portland",
      "seo_description": "Discover upscale living with quartz countertops at FortyOne 11 in Northeast Portland. Enjoy comfort and sophistication in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "king-neighborhood-floor-to-ceiling-windows",
      "search_query": "floor-to-ceiling windows apartments near King neighborhood",
      "category": "Amenity",
      "h1_title": "Floor-to-Ceiling Windows Near King Neighborhood",
      "h2_subtitle": "Discover the stunning floor-to-ceiling windows at FortyOne 11. Live close to the vibrant King neighborhood in Portland.",
      "page_copy": "Experience the breathtaking views and abundant natural light with the floor-to-ceiling windows at FortyOne 11, located near the lively King neighborhood in Portland. Our apartments are designed to let the outside in, making your living space feel expansive and connected to the vibrant surroundings. Nestled in Multnomah County, our community offers an aesthetic and functional environment.\n\nBeyond the beauty of floor-to-ceiling windows, FortyOne 11 provides a variety of features that make life convenient and enjoyable. With vaulted ceilings adding to the airy feel, and fully-equipped fitness facilities featuring cardio machines and free weights, you'll find everything you need right at home. Secure package lockers and available gated parking further enhance your living experience. Enjoy unmatched style and comfort at FortyOne 11, just steps away from the King neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Floor-to-Ceiling Windows Near King Neighborhood",
      "seo_description": "Enjoy natural light and stunning views with floor-to-ceiling windows at FortyOne 11, near Portland's King neighborhood. Discover luxury living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "portland-or-one-bedroom-apartments-fortyone11",
      "search_query": "one bedroom apartments Portland OR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Portland, OR",
      "h2_subtitle": "Explore one bedroom apartments in Portland, OR at FortyOne 11. Enjoy modern amenities and a vibrant community setting.",
      "page_copy": "Find your perfect living space at FortyOne 11 with our inviting one bedroom apartments in Portland, OR. Situated in the spirited King neighborhood, our apartments provide a comfortable and stylish environment, ideal for individuals or couples looking for modern urban living. Enjoy proximity to everything Portland has to offer while reveling in the convenience and design of our thoughtfully laid-out units.\n\nOur one bedroom apartments come complete with energy-efficient stainless-steel appliances, adding both style and functionality to your kitchen. Community-wide amenities such as a fitness center with cardio machines and free weights, vaulted ceilings, and secure package lockers enhance your everyday experience. Discover the perfect blend of comfort and convenience at FortyOne 11 today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Portland, OR",
      "seo_description": "Explore stylish one bedroom apartments at FortyOne 11 in Portland, OR. Enjoy modern amenities and a dynamic neighborhood environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166806",
      "source": "generator",
      "page_item_url": "king-portland-two-bedroom-apartments",
      "search_query": "two bedroom apartments near King Portland",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near King, Portland",
      "h2_subtitle": "Discover the spacious two bedroom apartments near King in Portland at FortyOne 11. Enjoy a vibrant location and modern amenities.",
      "page_copy": "At FortyOne 11, our two bedroom apartments near Portland's King neighborhood offer the perfect blend of space and convenience. Ideal for roommates or families, these apartments provide ample room to live, work, and relax. Situated in the heart of the dynamic King neighborhood, our location provides easy access to Portland's cultural and dining scenes.\n\nOur expansive two bedroom layouts are complemented by community amenities designed to enhance your lifestyle. Residents enjoy vaulted ceilings that enhance the airy feel of each apartment, a comprehensive fitness center complete with cardio machines and free weights, and the ease of package lockers. Gated and off-street parking options add an extra layer of convenience. Discover how FortyOne 11 combines comfort and elegance in Portland today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near King, Portland",
      "seo_description": "Explore spacious two bedroom apartments at FortyOne 11 near Portland's King neighborhood. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6020"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005284"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NZTXBQ66"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "563FT1"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('nUqmSniZFiGPoo3UgS')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41629066548"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp2djzxvxl"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "201210389"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_fortyone11_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/FortyOne 11/scheduletourwidget/JnnBCj0qp6blhpbqRI/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjI4ZmVWVHFyZUtsamxBN2wvVklEL0E9PSIsInZhbHVlIjoid2M1RExTSXlKTTNIQkJCNThJcG5Ydz09IiwibWFjIjoiYWE4YTNlNjE1ZjMyYzY5MjNmNmQ1ZjU1Mzc5ZWY3Njg4MzNhYTFmOTM1Y2VjZDNiOGYxNWMxNzkwNDJhZTZjNyJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6020",
  "custom_repli_id": "10715005284",
  "custom_google_gtm_id": "GTM-NZTXBQ66",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "563FT1",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('nUqmSniZFiGPoo3UgS')</script>",
  "custom_hubspot_company_id": "41629066548",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yjp2djzxvxl",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "201210389",
  "custom_website_tracking_email": "amcllc_fortyone11_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/FortyOne 11/scheduletourwidget/JnnBCj0qp6blhpbqRI/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjI4ZmVWVHFyZUtsamxBN2wvVklEL0E9PSIsInZhbHVlIjoid2M1RExTSXlKTTNIQkJCNThJcG5Ydz09IiwibWFjIjoiYWE4YTNlNjE1ZjMyYzY5MjNmNmQ1ZjU1Mzc5ZWY3Njg4MzNhYTFmOTM1Y2VjZDNiOGYxNWMxNzkwNDJhZTZjNyJ9",
  "custom_audioeye_site_id": "b0a010ee-678a-444b-aa9b-25b699ae658d",
  "custom_audioeye_site_hash": "cf1c9e14edd0bab684399ecb5d8c3ba4"
};

export const generatedAt = '2026-10-08T21:31:33.940Z';
